module.exports = __webpack_public_path__ + "static/full03-46e66e745189c62df73217d8bb942a5f.png";